import { render } from "./IdeasDetail.vue?vue&type=template&id=2469e3a6&ts=true"
import script from "./IdeasDetail.vue?vue&type=script&lang=ts"
export * from "./IdeasDetail.vue?vue&type=script&lang=ts"

import "./IdeasDetail.vue?vue&type=style&index=0&id=2469e3a6&lang=css"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__